module.exports = __webpack_public_path__ + "img/brown-carpet-grass-11.42247451.png";